import TextField from '@material-ui/core/TextField';
import React, { Component } from 'react';

class BankAccountRow extends Component {
    render() {
        return (
            <div className='flex-form'>
                <TextField
                    fullWidth
                    disabled
                    variant="outlined"
                    value={this.props.row.partnerTypeLabel}
                    id={"partnerType"} />
                <TextField
                    fullWidth
                    disabled
                    variant="outlined"
                    value={this.props.row.partnerName}
                    id={"partnerName"} />
                <TextField
                    fullWidth
                    disabled
                    variant="outlined"
                    value={this.props.row.bankAccountNumber}
                    id={"bankAccountNumber"} />
            </div>
        )
    }
}
export default BankAccountRow;